import {
  Checkbox, TableCell, TableRow, TextField
} from "@material-ui/core";
import { useFormikContext } from "formik";
import { get, omit } from "lodash";
import React, { useCallback, useEffect } from "react";

import ConfirmationCellContent from "./ConfirmationCellContent";

import NoActionNeeded from "./NoActionNeeded";
import PreAssignmentDescriptionPopover from "./PreAssignmentDescriptionPopover";

function PeoplenetIdConfirmationField({ fieldId }) {
  const { values, handleChange } = useFormikContext();

  const value = get(values, fieldId);

  const isChecked = value.basicConfirmed;

  return (
    <div style={{ fontSize: 16 }}>
      Confirm ID is correct <Checkbox color="primary" id={`${fieldId}.basicConfirmed`} checked={isChecked} onChange={handleChange} />
    </div>
  );
}

function StaticCellContent({ fieldId }) {
  const { values } = useFormikContext();

  const value = get(values, fieldId);

  return (
    <div>
      <TextField
        label="Peoplenet ID"
        value={value.peoplenetId}
        InputProps={{ disabled: true }}
        InputLabelProps={{ className: "disabled-input-label", shrink: true }}
      />
    </div>
  );
}

function EditableCellContent({ fieldId }) {
  const { values, setFieldValue, status, setStatus } = useFormikContext();

  const value = get(values, fieldId);

  const handlePeoplenetIdChange = useCallback((e) => {
    const newPeoplenetId = e.target.value;
    setFieldValue(`${fieldId}.peoplenetId`, newPeoplenetId);
    setFieldValue(`${fieldId}.basicConfirmed`, false);
  }, [setFieldValue, fieldId]);

  useEffect(() => {
    setStatus((status) => {
      return (omit(status, "submitErrors.peoplenet_id"));
    });
  }, [value.peoplenetId, setStatus]);

  const renderedErrorMessage = status?.submitErrors?.peoplenet_id;

  return (
    <div>
      <TextField
        label="Peoplenet ID"
        id={`${fieldId}.peoplenetId`}
        onChange={handlePeoplenetIdChange}
        error={Boolean(renderedErrorMessage)}
        helperText={renderedErrorMessage || ""}
        value={value.peoplenetId}
      />
      {value.peoplenetId && (
        <PeoplenetIdConfirmationField {...{ fieldId }} />
      )}
    </div>
  );
}

function PeoplenetIdRow({ checklistItem, editable, fieldId, candidate }) {
  return (
    <TableRow data-cy="checklist-item-confirmation-row">
      <TableCell>
        <div>
          <div className="bold">
            {checklistItem.name}
          </div>
        </div>
        <PreAssignmentDescriptionPopover {...checklistItem} />
      </TableCell>
      <TableCell align="center">
        <NoActionNeeded
          {...{
            checklistItem,
            editable,
            Editing: <EditableCellContent {...{ fieldId }} />,
            Viewing: <StaticCellContent {...{ fieldId }} />,
          }}
        />
      </TableCell>
      <TableCell>
        <ConfirmationCellContent {...{ checklistItem }} />
      </TableCell>
    </TableRow>
  );
}

export default PeoplenetIdRow;
